import React, { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import moment from "moment";
import { UrlApi } from "../../../services/apirest";
import { COLOR_MARCA } from "./constantes";

const formatearMonto = (valor) =>
  `$${Number(valor).toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// Gestiones de cuenta corriente del pedido (/gestion/:id_pedido): observaciones y montos.
function DialogGestionesCC({ pedido, onClose }) {
  const [gestiones, setGestiones] = useState(null);
  const [falloConsulta, setFalloConsulta] = useState(false);

  useEffect(() => {
    fetch(UrlApi + "/gestion/" + pedido.id_pedido)
      .then((res) => res.json())
      .then((data) => setGestiones(Array.isArray(data) ? data : []))
      .catch(() => setFalloConsulta(true));
  }, [pedido.id_pedido]);

  return (
    <Dialog open onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ bgcolor: COLOR_MARCA, color: "#fff" }}>
        Gestiones de cuenta corriente · Pedido #{pedido.id_pedido}
      </DialogTitle>
      <DialogContent sx={{ pt: "16px !important" }}>
        {falloConsulta ? (
          <Alert severity="error">No se pudieron obtener las gestiones.</Alert>
        ) : !gestiones ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 3 }}>
            <CircularProgress size={28} />
          </Box>
        ) : !gestiones.length ? (
          <Alert severity="info">El pedido no tiene gestiones de cuenta corriente.</Alert>
        ) : (
          <Stack spacing={1}>
            {gestiones.map((g) => (
              <Box
                key={g.id}
                sx={{ p: 1.25, border: "1px solid", borderColor: "divider", borderRadius: 1.5 }}
              >
                {g.observaciones ? (
                  <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
                    {g.observaciones}
                  </Typography>
                ) : null}
                {g.monto !== null && g.monto !== undefined ? (
                  <Typography variant="body2" fontWeight={700}>
                    Monto a abonar: {formatearMonto(g.monto)}
                  </Typography>
                ) : null}
                <Typography variant="caption" color="text.secondary">
                  {[g.usuario, g.created_at ? moment(g.created_at).format("DD-MM-YYYY HH:mm") : null]
                    .filter(Boolean)
                    .join(" · ")}
                </Typography>
              </Box>
            ))}
          </Stack>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cerrar</Button>
      </DialogActions>
    </Dialog>
  );
}

export default DialogGestionesCC;
